/* eslint-disable */
import Vue from 'vue';


import {
  Alert,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  Carousel,
  CarouselItem,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  Content,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Header,
  Icon,
  Input,
  InputNumber,
  Sider,
  Submenu,
  Layout,
  Menu,
  MenuGroup,
  MenuItem,
  Message,
  Modal,
  Option,
  Page,
  Poptip,
  Radio,
  RadioGroup,
  Row,
  Select,
  Table,
  Tabs,
  TabPane,
  Tag,
  Tooltip,
  Tree,
  Upload,
  Avatar,
  Switch,
  Notice,
  Spin,
  TimePicker,
  TreeSelect
} from 'view-design';
Vue.component('Alert', Alert);
Vue.component('TreeSelect', TreeSelect);
Vue.component('TimePicker', TimePicker);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('Button', Button);
Vue.component('Card', Card);
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
Vue.component('Cascader', Cascader);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Col', Col);
Vue.component('Content', Content);
Vue.component('DatePicker', DatePicker);
Vue.component('Divider', Divider);
Vue.component('Drawer', Drawer);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownItem', DropdownItem);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Header', Header);
Vue.component('Icon', Icon);
Vue.component('Input', Input);
Vue.component('InputNumber', InputNumber);
Vue.component('Sider', Sider);
Vue.component('Submenu', Submenu);
Vue.component('Menu', Menu);
Vue.component('MenuGroup', MenuGroup);
Vue.component('MenuItem', MenuItem);
Vue.component('Layout', Layout);
Vue.component('Modal', Modal);
Vue.component('Option', Option);
Vue.component('Page', Page);
Vue.component('Table', Table);
Vue.component('Poptip', Poptip);
Vue.component('Radio', Radio);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Row', Row);
Vue.component('Select', Select);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Tag', Tag);
Vue.component('Tooltip', Tooltip);
Vue.component('Tree', Tree);
Vue.component('Upload', Upload);
Vue.component('Message', Message);
Vue.component('Avatar', Avatar);
Vue.component('iSwitch', Switch);
Vue.component('Notice', Notice);
Vue.component('Spin', Spin);
/**
 * @description 页面相关提示
 */
Vue.prototype.$message = Message;
Vue.prototype.$Modal = Modal;
Vue.prototype.$Notice = Notice;
Vue.prototype.$Spin = Spin;
